import { feCommonDataHolder } from '@lastbrand/fe-common'

import { FALLBACK_LOCALE, LOCALE_COOKIE } from '@src/config/i18n.config'
import { parseBooleanEnv } from '@src/pages/util'
import getCookie from '@src/quince-site-common/src/utils/getCookie'

const env = process.env.NEXT_PUBLIC_FE_COMMON_ENV ?? 'PROD'
const enableI18n = parseBooleanEnv(process.env.NEXT_PUBLIC_ENABLE_I18N ?? 'false')

export const initializeFeCommon = () => {
  const locale = getCookie(LOCALE_COOKIE) ?? FALLBACK_LOCALE

  ;(
    feCommonDataHolder as {
      initialize: (options: { env: string; flags: { enableI18n: boolean }; locale: string }) => void
    }
  ).initialize({
    env,
    flags: {
      enableI18n,
    },
    locale,
  })
}
